/* eslint-disable react-hooks/exhaustive-deps */
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { Grid, Switch, FormControlLabel, FormGroup, Chip, Tooltip, IconButton, Box } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import { useEffect, useState, useContext } from "react";
import {
  postDigitalizacion,
  deleteImagesDigitalizaciones,
  actualizarDigitalizaciones,
} from "../../helpers/DigitalizacionData";
import {
  ocrAnalizarImagenes,
} from "../../helpers/OcrData";
import { getTiposContenidos } from "../../helpers/TipoContenidosData";
import { DigitalizacionesCaratula } from "./DigitalizacionesCaratula";
import AlertDialog from "./AlertDialogDelete";
import "../styles/Digitalizaciones.css";
import "react-medium-image-zoom/dist/styles.css";
import { SnackbarMessenger } from "../../../../general_components/SnackbarMessenger";
import { Buttons } from "../../../../general_components/Buttons";
import { FullFeaturedCrudGrid } from "./ListTableDigitalizaciones";
import { SimpleBackdrop } from "../../../../general_components/Backdrop";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { v4 as uuidv4 } from 'uuid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { SimpleDialogComponent } from "../../../../general_components/SimpleDialogComponent";
import { ConfimDialogComponent } from "../../../../general_components/ConfirmDialogComponent";
import esArray from "src/general_components/functionEsArray";
import CloseIcon from '@mui/icons-material/Close';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const DigitalizacionesContenido = (props) => {
  const {
    openDialogImage,
    contenidoSeleccionado,
    setOpenDialogImage,
    setAlertImagesSave,
    setActualizarListado,
    setEliminar,
    tipoContenidoList1,
    metadatosContenidoSeleccionado
  } = props;
  const {
    rows, setRows, setCheckedTotal, digitalizacionesSeleccionadas, setClickCheckedTotal,
    digitalizacionesSeleccionadasCompleto, setDigitalizacionesSeleccionadasCompleto, setDigitalizacionesAfacturar, checkedCaratula, digitalizaciones_coincidencias,
    ocrMode
  } = useContext(CajasContext);
  const [file, setFile] = useState([]);
  const [fileListPrimeraCarga, setFileListPrimeraCarga] = useState(true);
  const [tipoContenidoList, setTipoContenidoList] = useState(JSON.parse(localStorage.getItem("siam-tipo_contenidos"))?.tipo_contenidos || []);
  const [base64String, setBase64String] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [buttonSaveCaratula, setButtonSaveCaratula] = useState(true);
  // Buscar id_metadatos_defecto

  const cuentas_parametros = contenidoSeleccionado.cuentas_parametros || [];
  const nro_folio_cuentas_parametros = cuentas_parametros.find(item => item.alias === "FOLIO_INIT_NUMBER");
  const nro_folio_cuentas_parametros_value = nro_folio_cuentas_parametros ? parseInt(nro_folio_cuentas_parametros.valor) : null;
  const [nroFolio, setNroFolio] = useState(nro_folio_cuentas_parametros_value || 1);
  const [saveImagesCaratula, setSaveImagesCaratula] = useState(false);
  const [saveImagesDigitalizaciones, setSaveImagesDigitalizaciones] = useState(false);
  const [getDataSave, setGetDataSave] = useState(true);
  const [updateImageSave, setUpdateImageSave] = useState({});
  const [primerRender, setPrimerRender] = useState(true);
  const [abrirPreguntaConsumoImagenes, setAbrirPreguntaConsumoImagenes] = useState(false);
  //NOTE ESTADO PARA SABER SI HAY IMAGENES NUEVAS PARA ALMACENAR
  const [newImage, setNewImage] = useState(false);
  //NOTE STATE PARA DELETE
  const [alertDelete, setAlertDelete] = useState(false);
  const [index, setIndex] = useState(false);
  const [deleteTrue, setDeleteTrue] = useState(false);
  const [deleteStoredImage, setDeleteStoredImage] = useState(false);
  const [guardado, setGuardado] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  //NOTE STATE PARA LAS ALERTAS
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_perfil_usuario = user_data?.id_perfiles;
  const id_contenidos = contenidoSeleccionado?.id;
  const [checkedFiltroCoincidentes, setCheckedFiltroCoincidentes] = useState(false);
  const [rowsOriginal, setRowsOriginal] = useState([]);
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

  // OCR states
  const [ocrLoading, setOcrLoading] = useState(false);
  const [ocrResultados, setOcrResultados] = useState([]);
  const [ocrUmbral, setOcrUmbral] = useState(80);
  const [ocrError, setOcrError] = useState('');
  const [ocrSingleLoading, setOcrSingleLoading] = useState({});

  // OCR helpers
  const getOcrConfidenceColor = (confianza) => {
    if (confianza === null) return 'default';
    if (confianza >= 80) return 'success';
    if (confianza >= 50) return 'warning';
    return 'error';
  };

  const updateOcrValor = (globalIdx, newValor) => {
    setOcrResultados(prev => prev.map((r, i) => i === globalIdx ? { ...r, valor: newValor } : r));
  };

  const applyOcrCampo = (globalIdx, useOcr = true) => {
    const resultado = ocrResultados[globalIdx];
    if (!resultado || !resultado.id_metadatos) return;

    if (!useOcr) {
      setOcrResultados(prev => prev.map((r, i) => i === globalIdx ? { ...r, applied: true } : r));
      return;
    }

    const targetRow = rows[resultado.docIndex];
    if (!targetRow) return;

    const metaDatos = Array.isArray(targetRow.meta_datos) ? targetRow.meta_datos : [];
    const metaIndex = metaDatos.findIndex(m => String(m.id) === String(resultado.id_metadatos));

    setRows(rows.map((r, rIdx) => {
      if (rIdx !== resultado.docIndex) return r;
      const lista = Array.isArray(r.meta_datos) ? r.meta_datos : [];
      return {
        ...r,
        meta_datos: metaIndex !== -1
          ? lista.map((m, i) => i === metaIndex ? { ...m, valor: resultado.valor, fuente: 'ocr' } : m)
          : [...lista, { id: resultado.id_metadatos, valor: resultado.valor, fuente: 'ocr', id_metadato: '', label_form: resultado.label_metadatos || '' }],
      };
    }));
    setOcrResultados(prev => prev.map((r, i) => i === globalIdx ? { ...r, applied: true } : r));
  };

  const isConflict = (r) => {
    const targetRow = rows[r.docIndex];
    const metadatoMatch = (r.id_metadatos && targetRow && Array.isArray(targetRow.meta_datos))
      ? targetRow.meta_datos.find(m => String(m.id) === String(r.id_metadatos))
      : null;
    const valorActual = metadatoMatch ? metadatoMatch.valor : '';
    return !!(valorActual && valorActual !== '-' && valorActual !== r.valor);
  };

  const applyAllOcr = () => {
    let updatedRows = [...rows];
    const updatedResultados = ocrResultados.map((resultado) => {
      // Solo saltar los que no tienen mapeo a metadato
      if (!resultado.id_metadatos) return resultado;
      const targetRow = updatedRows[resultado.docIndex];
      if (!targetRow) return resultado;
      const lista = Array.isArray(targetRow.meta_datos) ? targetRow.meta_datos : [];
      const metaIndex = lista.findIndex(m => String(m.id) === String(resultado.id_metadatos));
      updatedRows = updatedRows.map((r, rIdx) => {
        if (rIdx !== resultado.docIndex) return r;
        const listaR = Array.isArray(r.meta_datos) ? r.meta_datos : [];
        return {
          ...r,
          meta_datos: metaIndex !== -1
            ? listaR.map((m, i) => i === metaIndex ? { ...m, valor: resultado.valor, fuente: 'ocr' } : m)
            : [...listaR, { id: resultado.id_metadatos, valor: resultado.valor, fuente: 'ocr', id_metadato: '', label_form: resultado.label_metadatos || '' }],
        };
      });
      return { ...resultado, applied: true };
    });

    // Persistir los cambios en updateImageSave para las filas ya guardadas
    let newUpdateImageSave = { ...updateImageSave };
    updatedRows.forEach(row => {
      if (row.save && row.id_digitalizaciones && Array.isArray(row.meta_datos)) {
        newUpdateImageSave[row.id_digitalizaciones] = row.meta_datos.map(meta => ({
          id_tipo_contenidos: meta.id_tipo_contenidos?.toString() || '',
          valor: meta.valor || '-',
          id: row.id_digitalizaciones,
          id_metadatos: meta.id,
          id_digitalizaciones_metadatos: meta.id_digitalizaciones_metadatos,
        }));
      }
    });

    setRows(updatedRows);
    setOcrResultados(updatedResultados);
    setUpdateImageSave(newUpdateImageSave);
    setDisableButton(false);
  };

  // OCR extraction handler
  const handleExtractOcr = async () => {
    setOcrLoading(true);
    setOcrError('');
    setOcrResultados([]);
    try {
      const tipoContenidoActual = tipoContenidoList.find(
        (tc) => String(tc.id) === String(contenidoSeleccionado.id_tipo_contenidos)
      );
      const id_ocr_plantilla = parseInt(tipoContenidoActual?.id_ocr_plantilla, 10) || null;
      if (!id_ocr_plantilla) {
        setOcrError('El tipo de contenido no tiene una plantilla OCR asignada.');
        setOcrLoading(false);
        return;
      }

      // Track original row indices so docIndex maps correctly to rows[]
      const rowsWithImages = rows
        .map((row, originalIdx) => ({ row, originalIdx }))
        .filter(({ row }) => row.image);

      const imagenes = rowsWithImages.map(({ row }) =>
        typeof row.image === 'string' && row.image.includes(',')
          ? row.image.split(',')[1]
          : row.image
      );

      if (imagenes.length === 0) {
        setOcrError('No hay imágenes para analizar.');
        setOcrLoading(false);
        return;
      }

      const res = await ocrAnalizarImagenes({
        id_plantilla: id_ocr_plantilla,
        id_contenidos: contenidoSeleccionado?.id || null,
        imagenes,
      });

      let resultadosPorImagen = [];
      let umbral = 80;
      try {
        const parsed = JSON.parse(atob(res?.wsResponse));
        // Soporta formato nuevo { umbral_confianza, resultados } y el legacy []
        if (Array.isArray(parsed)) {
          resultadosPorImagen = parsed;
        } else {
          resultadosPorImagen = parsed.resultados || [];
          umbral = parsed.umbral_confianza ?? 80;
        }
      } catch { /* nada */ }
      setOcrUmbral(umbral);

      const campos = [];
      resultadosPorImagen.forEach((doc) => {
        const originalIdx = rowsWithImages[doc.imagen_idx]?.originalIdx ?? doc.imagen_idx;
        if (Array.isArray(doc.campos)) {
          doc.campos.forEach((c) => {
            campos.push({
              campo: c.etiqueta || '',
              valor: c.valor_extraido || '',
              confianza: c.confianza !== undefined ? parseFloat(c.confianza) : null,
              id_metadatos: c.id_metadatos || null,
              label_metadatos: c.label_metadatos || null,
              docIndex: originalIdx,
              imagenNum: doc.imagen_idx + 1,
              applied: false,
            });
          });
        }
      });
      setOcrResultados(campos);
    } catch (err) {
      setOcrError('Error al ejecutar OCR: ' + (err?.message || 'desconocido'));
    } finally {
      setOcrLoading(false);
    }
  };

  const handleExtractOcrSingle = async (rowIndex) => {
    const row = rows[rowIndex];
    if (!row || !row.image) return;
    setOcrSingleLoading(prev => ({ ...prev, [rowIndex]: true }));
    setOcrError('');
    try {
      const tipoContenidoActual = tipoContenidoList.find(
        tc => String(tc.id) === String(contenidoSeleccionado.id_tipo_contenidos)
      );
      const id_ocr_plantilla = parseInt(tipoContenidoActual?.id_ocr_plantilla, 10) || null;
      if (!id_ocr_plantilla) {
        setOcrError('El tipo de contenido no tiene plantilla OCR asignada.');
        return;
      }
      const imageB64 = typeof row.image === 'string' && row.image.includes(',')
        ? row.image.split(',')[1]
        : row.image;
      const res = await ocrAnalizarImagenes({ id_plantilla: id_ocr_plantilla, id_contenidos: contenidoSeleccionado?.id || null, imagenes: [imageB64] });
      let resultados = [];
      let umbral = 80;
      try {
        const parsed = JSON.parse(atob(res?.wsResponse));
        if (Array.isArray(parsed)) { resultados = parsed; }
        else { resultados = parsed.resultados || []; umbral = parsed.umbral_confianza ?? 80; }
      } catch { }
      setOcrUmbral(umbral);
      const nuevos = (resultados[0]?.campos || []).map(c => ({
        campo: c.etiqueta || '',
        valor: c.valor_extraido || '',
        confianza: c.confianza !== undefined ? parseFloat(c.confianza) : null,
        id_metadatos: c.id_metadatos || null,
        label_metadatos: c.label_metadatos || null,
        docIndex: rowIndex,
        imagenNum: rowIndex + 1,
        applied: false,
      }));
      setOcrResultados(prev => [...prev.filter(r => r.docIndex !== rowIndex), ...nuevos]);
    } catch (err) {
      setOcrError('Error OCR: ' + (err?.message || 'desconocido'));
    } finally {
      setOcrSingleLoading(prev => ({ ...prev, [rowIndex]: false }));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      let tipoContenidos = tipoContenidoList;

      if (tipoContenidoList.length === 0) {
        tipoContenidos = await getTiposContenidos(true);
        setTipoContenidoList(tipoContenidos);
      }

      if (base64String !== "") {
        const newImageRow = {
          model: "digitalizaciones",
          model_data: {
            id_tipo_contenidos:  contenidoSeleccionado.id_tipo_contenidos || "",
            id_contenidos: contenidoSeleccionado.id,
            folio: nroFolio,
            valor: "",
          },
          save: false,
          image: base64String,
          folio: nroFolio,
          id: uuidv4(),
          descripcion: "",
          id_tipo_contenidos: contenidoSeleccionado.id_tipo_contenidos || "",
          checked: false,
          tipo_contenidos: (() => {
            const item = tipoContenidos.find(item => item.id === contenidoSeleccionado.id_tipo_contenidos);
            return item ? `${item.id} - ${item.detalle}` : "";
          })(),

        };

        setRows([newImageRow, ...rows]);
        setNewImage(true);
        setNroFolio(parseInt(nroFolio) + 1);
        setBase64String("");
        setLoading(false);
      }

      if (contenidoSeleccionado.digitalizaciones && file.length === 0 && getDataSave) {
        const result = await getImagesSave(contenidoSeleccionado.id, contenidoSeleccionado.digitalizaciones, tipoContenidos);
        if (result.cantFolio !== 0) {
          setNroFolio(result.cantFolio);
        }

        setFile(result.saveImages);

        if (fileListPrimeraCarga) {
          let arrayImagenesGuardadas = result.saveImages.sort((x, y) => x.model_data.folio - y.model_data.folio);

          if (arrayImagenesGuardadas) {
            let dataRows = arrayImagenesGuardadas.map((image, index) => {
              let idDigitalizacionEncontrado = digitalizacionesSeleccionadasCompleto.digitalizaciones_contenidos.find(element => element === image.id_digitalizaciones);
              let checked = idDigitalizacionEncontrado ? true : false;

              return {
                ...image,
                folio: image.model_data.folio,
                id_tipo_contenidos: image.model_data.id_tipo_contenidos.id ? image.model_data.id_tipo_contenidos.id : image.model_data.id_tipo_contenidos,
                descripcion: image.model_data.valor,
                id: image.model_data.folio ? uuidv4() : "A" + index,
                checked: checked
              };
            });

            dataRows = dataRows.filter(item => item.image !== "");
            if (dataRows.length > 0) {
              setNroFolio(dataRows.length + 1);
            }

            setRows(dataRows);
          }

          setFileListPrimeraCarga(false);
        }
      }

      setGetDataSave(false);

      if (buttonSaveCaratula === false && newImage === false) {
        setDisableButton(false);
      } else if (Object.entries(updateImageSave).length > 0 && !eliminando) {
        setDisableButton(false);
      } else if (newImage) {
        let sinMetadatos = false;

        rows.forEach(row => {
          if (!row.meta_datos || row.meta_datos?.length < 1) {

            sinMetadatos = true;

            return;
          }

        });

        if (sinMetadatos) {
          setDisableButton(false);
        } else {
          setDisableButton(false);
        }
      } else {
        setDisableButton(true);
      }

      if (saveImagesDigitalizaciones && newImage && !guardado) {
        setGuardado(true);
        await postDigitalizacionContenido();
      } else if (saveImagesDigitalizaciones && !newImage) {
        setOpenDialogImage(!openDialogImage);
        setSaveImagesDigitalizaciones(!saveImagesDigitalizaciones);
      }
    };

    fetchData();
  }, [
    base64String,
    file,
    rows,
    saveImagesDigitalizaciones,
    disableButton,
    contenidoSeleccionado,
    buttonSaveCaratula,
    deleteStoredImage,
    getDataSave,
    tipoContenidoList,
    fileListPrimeraCarga,
    digitalizacionesSeleccionadasCompleto,
    guardado,
    newImage,
    nroFolio,
    updateImageSave,
    eliminando,
  ]);


  //NOTE CUANDO SE SELECCIONA UNA IMAGEN SE PASA DIRECTAMENTE A BASE 64
const postDigitalizacionContenido = async () => {
  const rowsUpdate = rows.map((row) => {
    const metaDatos = Array.isArray(row.meta_datos) ? row.meta_datos : [{}];

    const model_data = metaDatos.map((metadato) => ({
      folio: row.folio?.toString() || "",
      id_contenidos: id_contenidos,
      id_tipo_contenidos: metadato.id_tipo_contenidos || row.id_tipo_contenidos || "",
      id_metadatos: metadato.id || "",
      valor: metadato.valor || "",
      fuente: metadato.fuente || "standard",
    }));

    return {
      ...row,
      model_data, // siempre tiene al menos un elemento con estructura vacía
    };
  });

  const rowsUpdate_SinMeta_datos = rowsUpdate.map((row) => {
    const { meta_datos, checked, descripcion, folio, id, id_tipo_contenidos, ...resto } = row;
    return resto;
  });
  
  const respuesta = await postDigitalizacion(rowsUpdate_SinMeta_datos);

  setOpenDialogImage(!openDialogImage);
  setNewImage(!newImage);
  setSaveImagesDigitalizaciones(!saveImagesDigitalizaciones);

  if (respuesta.status === "true") {
    setGuardado(false);
    setAlertImagesSave(true);
  } else {
    setAlertImagesSave(false);
    setGuardado(false);
  }
};



  //NOTE CUANDO SE SELECCIONA UNA IMAGEN SE PASA DIRECTAMENTE A BASE 64
  const deleteDigitalizacionContenido = async (event) => {
    setEliminando(true);
    let newRows = [...rows];
    if (rows[index].save) {
      const respuesta = await deleteImagesDigitalizaciones(
        rows[index]?.id_digitalizaciones
      );
      // Se muestra los mensajes corresponientes al status del servicio
      // Se retorna un mensaje con la cantidad de contenidos encontrados
      // Sino se muestra un mensaje de que no se encontraron contenidos
      if (respuesta === "true") {
        setDeleteStoredImage(false);
        setEliminar(true);
        setActualizarListado(true);
        setSnackbarVisible(true);
        setSeverity("success");
        setMessage("Se elimino la digitalizacion del contenido correctamente");
        newRows.splice(index, 1);
        /// Actualizar orden
        newRows = newRows.sort((x, y) => x.model_data.folio - y.model_data.folio);
        for (var ind = 0; ind < newRows.length; ind++) {
          // eslint-disable-next-line no-loop-func
          let indexRow = newRows.findIndex(function (newRow) {
            // eslint-disable-next-line eqeqeq
            return newRow.id == newRows[ind].id; // or el.nombre=='T NORTE';
          });
          newRows[ind].folio = indexRow + 1;
          newRows[ind].model_data.folio = indexRow + 1;
          newRows[ind].checked = false;
        }
        let rowsOrderEdit = updateImageSave;
        for (var i2 = 0; i2 < newRows.length; i2++) {
          if (newRows[i2].save) {

            rowsOrderEdit = {
              ...rowsOrderEdit,
              [newRows[i2].id_digitalizaciones]: {
                ...rowsOrderEdit[
                newRows[i2].id_digitalizaciones
                ],
                folio: newRows[i2].folio.toString(),
                id: newRows[i2].id_digitalizaciones,
              },
            };
          }
        }
        await saveFolio(rowsOrderEdit);
      } else {
        setDeleteStoredImage(false);
        setSnackbarVisible(true);
        setSeverity("warning");
        setMessage("Hubo un error al eliminar la digitalizacion del contenido");
      }
      setIndex("");
    } else {
      newRows.splice(index, 1);
      newRows = newRows.sort((x, y) => x.model_data.folio - y.model_data.folio);
      for (var i = 0; i < newRows.length; i++) {
        // eslint-disable-next-line no-loop-func
        let indexRow = newRows.findIndex(function (newRow) {
          return newRow.id === newRows[i].id; // or el.nombre=='T NORTE';
        });
        newRows[i].folio = indexRow + 1;
        newRows[i].model_data.folio = indexRow + 1;
        newRows[i].checked = false;
      }
      //NOTE FUNCION PARA SABER SI SE SACAN TODAS LAS IMAGENES PARA ALMACENAR
      const imagesNews = newRows.filter((item) => item.save === false);
      if (imagesNews.length === 0) {
        setNewImage(false);
      }
      setSnackbarVisible(true);
      setSeverity("success");
      setMessage("Se elimino la digitalizacion del contenido correctamente");
      setIndex("");
    }
    let rowsOrdenado = newRows.sort((x, y) => x.model_data.folio - y.model_data.folio);
    setRows(rowsOrdenado);
    setNroFolio(nroFolio - 1);
    setDeleteTrue(false);
    setEliminando(false);
  };


  //NOTE CUANDO SE SELECCIONA UNA IMAGEN SE PASA DIRECTAMENTE A BASE 64
  const uploadImages = async (event) => {
    let fileObj = [];
    fileObj.push(event.target.files);
    // let files =  fileObj.sort((x, y) => x.name - y.z);
    let files = [...event.target.files].sort((a, b) => a.name.localeCompare(b.name));
    // let files = fileObj[0].sort((unArchivo, otroArchivo) => unArchivo.name.localeCompare(otroArchivo.name));
    for (let i = 0; i < files.length; i++) {
      setLoading(true);
      let imageBase64 = await convertImageToBase64(
        URL.createObjectURL(fileObj[0][i]),
        event.target.files[0].name
      );
      setBase64String(imageBase64);
    }
  };


  //NOTE FUNCION PARA PASAR LAS IMAGENES A BASE 64, PARA PODER ALMACENARLAS EN LA BASE DE DATOS
  const convertImageToBase64 = async (url, name) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }


  //NOTE FUNCION PARA GUARDAR LOS FOLIOS AL ELIMINAR REGISTRO GUARDADO
  const saveFolio = async (rowsOrderEdit) => {
    if (Object.entries(rowsOrderEdit).length > 0) {
      // TODO: Analizar respuesta y mostrar mensaje en caso de error
      const respuesta = await actualizarDigitalizaciones(rowsOrderEdit);
      return respuesta;
    }
  };

  //NOTE FUNCION PARA GUARDAR LAS IMAGENES
  const onClickSubmit = async () => {
    setLoading(true);
    if (Object.entries(updateImageSave).length > 0) {
      const respuesta = await actualizarDigitalizaciones(updateImageSave);
      if (respuesta.status === "true") {
        setAlertImagesSave(true);
      } else {
        setAlertImagesSave(false);
      }
    }
    setSaveImagesCaratula(!saveImagesCaratula);
  };


  //NOTE FUNCION PARA FACTURAR
  // const onClickFacturar = async () => {
  //   let filesImages = [];
  //   rows.forEach((item) => {
  //     if (item.save === false && item.checked) {
  //       filesImages.push(item);
  //     }
  //   });
  //   if (filesImages.length > 0) {
  //     // setDigitaliazacionesNuevosChecked(filesImages)
  //     setAbrirPreguntaConsumoImagenes(true);
  //   } else {
  //     if (digitalizacionesSeleccionadas.digitalizaciones_contenidos) {
  //       setDigitalizacionesSeleccionadasCompleto(digitalizacionesSeleccionadas);
  //       setDigitalizacionesAfacturar(digitalizacionesSeleccionadas)
  //       handleClose(false);
  //     }
  //   }
  // };


  //NOTE FUNCION PARA FACTURAR sin guardar nuevas digitalizaciones
  const onClickFacturarSinGuardar = async () => {
    if (digitalizacionesSeleccionadas.digitalizaciones_contenidos) {
      setDigitalizacionesSeleccionadasCompleto(digitalizacionesSeleccionadas);
      setDigitalizacionesAfacturar(digitalizacionesSeleccionadas)
      handleClose(false);
    }
  };


  useEffect(() => {
    if (deleteTrue) {
      deleteDigitalizacionContenido();
    }
  }, [deleteTrue]);


  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "rgb(244, 246, 248)",
      color: "#637381",
      fontSize: 14,
      fontWeight: 'bold',
      borderRadius: 0,
      verticalAlign: 'inherit',
      border: '1px dashed rgb(241, 243, 244)',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  function filtrarPorIdDigitalizacionesCoincidente(array, id_digitalizaciones_filtro) {
    const idsFiltro = id_digitalizaciones_filtro.split(',');

    return array.filter(item => idsFiltro.includes(item.id_digitalizaciones));
  }

  // Funcion Checkbox
  const handleChangeFiltroCoincidentes = (event) => {
    setCheckedFiltroCoincidentes(event.target.checked);
    if (event.target.checked) {
      setRowsOriginal(rows);
      const rows_filtrado = filtrarPorIdDigitalizacionesCoincidente(rows, digitalizaciones_coincidencias);
      setRows(rows_filtrado);
    } else {
      setRows(rowsOriginal);
      setRowsOriginal([]);
    }
  };


  // Cierre real del diálogo (sin guardar)
  const doClose = () => {
    setOpenDialogImage(false);
    setCheckedTotal(false);
    setAbrirPreguntaConsumoImagenes(false);
    setClickCheckedTotal(false);
    setConfirmCloseOpen(false);
  };

  // Funcion Que cieera los modales
  // Cuando value === false es un cierre programático (post-facturación) que no requiere confirmación
  const handleClose = (value) => {
    const hasUnsaved = newImage || Object.entries(updateImageSave).length > 0;
    if (hasUnsaved && value !== false) {
      setConfirmCloseOpen(true);
      return;
    }
    doClose();
  };


  // Funcion Que cieera el modal aviso
  const handleCloseAviso = (value) => {
    setAbrirPreguntaConsumoImagenes(false);
    setClickCheckedTotal(false);
  };


  useEffect(() => {
    if (rows.length > 0 && primerRender) {
      let cantRow = rows.length;
      let cantRowChecked = rows.filter((item) => item.id_digitalizaciones && item.checked !== false).length;
      setCheckedTotal(cantRow === cantRowChecked && checkedCaratula ? true : false);
      setPrimerRender(false);
    }
  }, [rows]);


  //NOTE FUNCION PARA consumir servicio de imagenes 
  const onClickImagenesFacturas = async () => {
    const rowsUpdate = rows.map((row) => {
      row.model_data.id_tipo_contenidos = row.id_tipo_contenidos;
      row.model_data.folio = row.folio.toString();
      row.model_data.valor = row.descripcion;
      return row;
    });
    const respuesta = await postDigitalizacion(rowsUpdate);
    if (respuesta.status === "true") {
      if (respuesta.wsResponse.images) {
        let newDigitalizaciones = esArray(respuesta.wsResponse.images.image);
        newDigitalizaciones = newDigitalizaciones.map((row) => {
          return row.id_modelo_padre;
        });
        if (digitalizacionesSeleccionadas.digitalizaciones_contenidos) {
          let digitalizacionContPrevio = [...digitalizacionesSeleccionadas.digitalizaciones_contenidos];
          let digitalizacionContFinal = digitalizacionContPrevio.concat(newDigitalizaciones);
          setDigitalizacionesSeleccionadasCompleto({ ...digitalizacionesSeleccionadasCompleto, digitalizaciones_contenidos: digitalizacionContFinal });
          setDigitalizacionesAfacturar({ ...digitalizacionesSeleccionadasCompleto, digitalizaciones_contenidos: digitalizacionContFinal })
          setActualizarListado(true);
          handleClose(false);
        }
      }
    } else {
      setSnackbarVisible(true);
      setSeverity("warning");
      setMessage(respuesta.message);
    }
  };


  const Title = styled(Typography)(({ theme }) => ({
    color: '#FFFFFF', // Color blanco para el título
    fontWeight: 'bold', // Puedes ajustar el peso de la fuente según tus preferencias
    fontSize: '1rem', // Tamaño de la fuente del título
    marginBottom: theme.spacing(0), // Espacio inferior para separar del contenido
  }));


  const CloseButton = styled(Button)(({ theme }) => ({
    color: '#FFFFFF',
  }));


  const Header = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0),
  }));

  // Establece el estado inicial del acordeón como expandido
  const [expanded, setExpanded] = useState(true);

  const handleChangeAccordeon = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };


  return (
    <>
      {alertDelete && (
        <AlertDialog
          alertDelete={alertDelete}
          setDeleteTrue={setDeleteTrue}
          setAlertDelete={setAlertDelete}
        />
      )}
      <Dialog fullWidth={true} maxWidth={"xl"} open={openDialogImage} fullScreen={true}>
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #0A395F 0%, #1565C0 100%)',
          color: 'white',
          py: 1.5,
          px: 2,
        }}>
          <Header>
            <div>
              <Title>Listado de Digitalizaciones</Title>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', display: 'block' }}>
                Contenido #{contenidoSeleccionado?.id}
                {contenidoSeleccionado?.id_tipo_contenidos ? ` · Tipo ${contenidoSeleccionado.id_tipo_contenidos}` : ''}
                {` · ${rows.length} ${rows.length === 1 ? 'imagen' : 'imágenes'}`}
              </Typography>
            </div>
            <CloseButton onClick={handleClose}>
              <CloseIcon />
            </CloseButton>
          </Header>
        </DialogTitle>

        {guardado ? (<SimpleBackdrop open={true}></SimpleBackdrop>) : (<></>)}

        <DialogContent sx={{ p: 2 }}>

          {/* Sección: Información del documento */}
          <Accordion expanded={expanded} onChange={handleChangeAccordeon}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Información del documento
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2} style={{ paddingTop: "8px" }}>
                <Grid item xs={12} md={3}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.5 }}>
                    Metadatos del contenido
                  </Typography>
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small" aria-label="metadatos del contenido">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="left">Campo</StyledTableCell>
                          <StyledTableCell align="left">Valor</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {metadatosContenidoSeleccionado.length > 0
                          ? metadatosContenidoSeleccionado.map((metadato) =>
                            metadato.label !== "id_metadatos" && metadato.label !== "id_contenidos" && metadato.label !== "id_caja"
                              ? (
                                <TableRow key={metadato.label}>
                                  <TableCell sx={{ fontSize: 11, fontWeight: 'bold' }} variant="head">
                                    {metadato.label.replace(/[_]/g, ' ').toUpperCase()}
                                  </TableCell>
                                  <TableCell sx={{ fontSize: 11 }}>{metadato.valor}</TableCell>
                                </TableRow>
                              ) : null
                          )
                          : null}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid item xs={12} md={9}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.5 }}>
                    Imágenes de carátula
                  </Typography>
                  <DigitalizacionesCaratula
                    contenidoSeleccionado={contenidoSeleccionado}
                    saveImagesCaratula={saveImagesCaratula}
                    setSaveImagesCaratula={setSaveImagesCaratula}
                    setSaveImagesDigitalizaciones={setSaveImagesDigitalizaciones}
                    setButtonSaveCaratula={setButtonSaveCaratula}
                    setActualizarListado={setActualizarListado}
                    setAlertImagesSave={setAlertImagesSave}
                    setEliminar={setEliminar}
                    guardado={guardado}
                    setLoadingContenido={setLoading}
                    loadingContenido={loading}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          {/* Toolbar: filtrar + subir imágenes + OCR global */}
          <Paper variant="outlined" sx={{ p: 1.5, mt: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <FormGroup>
              <FormControlLabel
                control={<Switch size="small" checked={checkedFiltroCoincidentes} onChange={handleChangeFiltroCoincidentes} name="gilad" />}
                label={<Typography variant="body2">Filtrar coincidentes</Typography>}
              />
            </FormGroup>

            <Button
              hidden={id_perfil_usuario === "9" ? true : false}
              variant="contained"
              component="label"
              size="small"
              endIcon={<PhotoCamera />}
            >
              Agregar imágenes
              <input hidden accept="image/*" multiple type="file" onChange={uploadImages} />
            </Button>

            {ocrMode && (
              <Stack direction="row" alignItems="center" spacing={1} sx={{ ml: 'auto' }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  startIcon={ocrLoading ? <CircularProgress size={14} /> : <AutoFixHighIcon />}
                  disabled={ocrLoading || rows.filter(r => r.image).length === 0}
                  onClick={handleExtractOcr}
                >
                  {ocrLoading ? 'Extrayendo...' : `Extraer OCR (${rows.filter(r => r.image).length} imágenes)`}
                </Button>
                {ocrError && (
                  <Typography color="error" variant="caption">{ocrError}</Typography>
                )}
              </Stack>
            )}
          </Paper>

          {/* Resultados OCR (fuera del accordion, bien visibles) */}
          {ocrMode && ocrResultados.length > 0 && (() => {
            const groups = {};
            ocrResultados.forEach((r, globalIdx) => {
              const key = r.docIndex;
              if (!groups[key]) groups[key] = [];
              groups[key].push({ ...r, globalIdx });
            });

            const pendientes = ocrResultados.filter(r => !r.applied && r.id_metadatos).length;
            const aplicados = ocrResultados.filter(r => r.applied).length;

            return (
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Resultados OCR
                    </Typography>
                    <Chip label={`${ocrResultados.length} campos`} size="small" variant="outlined" />
                    {aplicados > 0 && <Chip label={`${aplicados} aplicados`} size="small" color="success" variant="outlined" />}
                    {pendientes > 0 && <Chip label={`${pendientes} pendientes`} size="small" color="warning" variant="outlined" />}
                  </Stack>
                  <Tooltip title="Aplica todos los campos OCR que tienen metadato mapeado. Los campos sin mapeo se ignoran.">
                    <Button size="small" variant="contained" color="primary" onClick={applyAllOcr}>
                      Aplicar todos
                    </Button>
                  </Tooltip>
                </Box>

                {Object.entries(groups).map(([docIdxStr, campos]) => {
                  const docIdx = parseInt(docIdxStr);
                  const targetRow = rows[docIdx];
                  const folio = targetRow?.folio ?? targetRow?.model_data?.folio ?? (docIdx + 1);
                  const imagenNum = campos[0]?.imagenNum ?? (docIdx + 1);
                  const camposAplicados = campos.filter(c => c.applied).length;
                  return (
                    <Accordion key={docIdx} defaultExpanded sx={{ mb: 1 }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%', pr: 2 }}>
                          <Typography variant="subtitle2">
                            Imagen {imagenNum} · Nro. Imagen {folio}
                          </Typography>
                          {camposAplicados > 0 && (
                            <Chip label={`${camposAplicados}/${campos.length} aplicados`} size="small" color="success" />
                          )}
                        </Stack>
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0 }}>
                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>Campo</StyledTableCell>
                                <StyledTableCell>Metadato destino</StyledTableCell>
                                <StyledTableCell>Valor actual</StyledTableCell>
                                <StyledTableCell>Valor OCR</StyledTableCell>
                                <StyledTableCell>Confianza</StyledTableCell>
                                <StyledTableCell align="center">Acción</StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {campos.map((r) => {
                                const metadatoLabel = r.label_metadatos || null;
                                const metadatoMatch = (r.id_metadatos && targetRow && Array.isArray(targetRow.meta_datos))
                                  ? targetRow.meta_datos.find(m => String(m.id_metadatos ?? m.id) === String(r.id_metadatos))
                                  : null;
                                const valorActual = metadatoMatch ? metadatoMatch.valor : '';
                                const hasConflict = !!(valorActual && valorActual !== '-' && valorActual !== r.valor);
                                const valorExcede = r.valor && r.valor.length > 75;
                                return (
                                  <TableRow
                                    key={r.globalIdx}
                                    sx={{
                                      backgroundColor: r.applied
                                        ? 'rgba(76, 175, 80, 0.08)'
                                        : hasConflict
                                          ? 'rgba(255, 152, 0, 0.06)'
                                          : 'inherit'
                                    }}
                                  >
                                    <TableCell>{r.campo}</TableCell>
                                    <TableCell>
                                      {metadatoLabel
                                        ? metadatoLabel
                                        : r.id_metadatos
                                          ? <Typography variant="caption" color="text.secondary">{`ID ${r.id_metadatos}`}</Typography>
                                          : <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>Sin mapeo</Typography>
                                      }
                                    </TableCell>
                                    <TableCell sx={{ color: hasConflict ? 'warning.main' : 'inherit', fontWeight: hasConflict ? 600 : 'inherit' }}>
                                      {valorActual || <Typography variant="caption" color="text.disabled">—</Typography>}
                                    </TableCell>
                                    <TableCell sx={{ minWidth: 140 }}>
                                      <Stack direction="row" alignItems="center" spacing={0.5}>
                                        <input
                                          value={r.valor}
                                          onChange={(e) => updateOcrValor(r.globalIdx, e.target.value)}
                                          style={{
                                            width: '100%',
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                            padding: '2px 6px',
                                            fontSize: '0.8125rem',
                                            fontFamily: 'inherit',
                                            backgroundColor: 'transparent',
                                            color: 'inherit',
                                          }}
                                        />
                                        {valorExcede && (
                                          <Tooltip title="El valor supera los 75 caracteres permitidos">
                                            <WarningIcon color="warning" fontSize="small" />
                                          </Tooltip>
                                        )}
                                      </Stack>
                                    </TableCell>
                                    <TableCell>
                                      {r.confianza !== null ? (
                                        <Chip
                                          label={`${Math.round(r.confianza)}%`}
                                          size="small"
                                          color={getOcrConfidenceColor(r.confianza)}
                                        />
                                      ) : <Typography variant="caption" color="text.disabled">—</Typography>}
                                    </TableCell>
                                    <TableCell align="center">
                                      {r.applied ? (
                                        <Chip label="Aplicado" size="small" color="success" variant="outlined" />
                                      ) : hasConflict ? (
                                        <Stack direction="row" spacing={0.5} justifyContent="center">
                                          <Tooltip title="Sobreescribir con el valor OCR">
                                            <span>
                                              <Button size="small" variant="outlined" color="warning" disabled={!r.id_metadatos} onClick={() => applyOcrCampo(r.globalIdx, true)}>
                                                Usar OCR
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <Tooltip title="Conservar el valor existente">
                                            <Button size="small" variant="outlined" color="inherit" onClick={() => applyOcrCampo(r.globalIdx, false)}>
                                              Mantener
                                            </Button>
                                          </Tooltip>
                                        </Stack>
                                      ) : (
                                        <Tooltip title={!r.id_metadatos ? 'Sin mapeo a metadato' : (valorExcede ? 'Valor supera 75 caracteres' : 'Aplicar valor OCR al metadato')}>
                                          <span>
                                            <Button size="small" variant="outlined" color="primary" disabled={!r.id_metadatos} onClick={() => applyOcrCampo(r.globalIdx, true)}>
                                              Aplicar
                                            </Button>
                                          </span>
                                        </Tooltip>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </Box>
            );
          })()}

          {/* Grilla de imágenes */}
          {loading || getDataSave || guardado ? (
            <Grid style={{ textAlign: "center", marginTop: 16 }}>
              <CircularProgress style={{ width: "50px", height: "50px" }} />
            </Grid>
          ) : (
            <Box sx={{ mt: 2 }}>
              <FullFeaturedCrudGrid
                tipoContenidoList={tipoContenidoList1}
                updateImageSave={updateImageSave}
                setUpdateImageSave={setUpdateImageSave}
                setNroFolio={setNroFolio}
                nroFolio={nroFolio}
                setAlertDelete={setAlertDelete}
                setIndex={setIndex}
                nro_folio_cuentas_parametros_value={nro_folio_cuentas_parametros_value}
                ocrResultados={ocrResultados}
                ocrUmbral={ocrUmbral}
                onOcrApply={(globalIdx) => setOcrResultados(prev => prev.map((r, i) => i === globalIdx ? { ...r, applied: true } : r))}
                onOcrSingleExtract={handleExtractOcrSingle}
                ocrSingleLoading={ocrSingleLoading}
              />
            </Box>
          )}
        </DialogContent>

        <Box sx={{ px: 3, pb: 2 }}>
          <Buttons
            disableButton={disableButton}
            onClickSubmit={onClickSubmit}
            buttonCerrar={handleClose}
            hiddenButtons={id_perfil_usuario === "9" ? true : false}
          />
        </Box>
      </Dialog>

      {abrirPreguntaConsumoImagenes && (
        <SimpleDialogComponent
          open={abrirPreguntaConsumoImagenes}
          modalName={"Aviso"}
          child={
            <Grid sx={{ mt: 1, minWidth: "100%", textAlign: "center", wordBreak: "break-all" }}>
              <WarningIcon sx={{ fontSize: "400%", color: "yellow" }} />
              <Typography align="center" variant="h4" gutterBottom component="div">
                ATENCIÓN
              </Typography>
              <Grid>
                <Typography align="center" variant="h5">
                  "Se han seleccionado digitalizaciones que aún no están almacenadas en la base de datos. Si desea guardarlas haga click en Guardar y Confirmar, sino en Descartar y Confirmar."
                </Typography>
              </Grid>
              <Grid sx={{ paddingTop: "30px" }}>
                <Buttons
                  onClickSubmit={onClickImagenesFacturas}
                  disableButton={disableButton}
                  labelButtonSave={"Guardar y Confirmar"}
                  buttonCerrar={handleCloseAviso}
                  buttonFacturar={true}
                  onClickFacturar={onClickFacturarSinGuardar}
                  labelButtonFacturar={"Descartar y Confirmar"}
                  iconFacturarDisabled={true}
                />
              </Grid>
            </Grid>
          }
          setPushData={onClickImagenesFacturas}
          handleClose={handleCloseAviso}
          buttonEnviar={false}
          buttonCancelar={true}
        />
      )}

      {confirmCloseOpen && (
        <ConfimDialogComponent
          open={confirmCloseOpen}
          modalName={"Salir sin guardar"}
          mensaje={"Hay cambios sin guardar. ¿Desea salir de todas formas?"}
          handleConfirm={doClose}
          handleClose={() => setConfirmCloseOpen(false)}
          maxWidth="xs"
        />
      )}

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => { setSnackbarVisible(false); }}
      />
    </>
  );
};

const getImagesSave = async (
  idContenido,
  imagenesDigitalizaciones,
  tipoContenidoList
) => {
  let saveImages = [];
  let cantFolio = 0;

  const formatValor = (valor) => {
    return valor !== undefined && valor !== null && valor !== "" ? valor : "-";
  };
  /**
   * ORDENO LA DATA PARA PODER DEJARLA EN UN SOLO ARRAY DE OBJETOS, PARA PODER MOSTRARLA MAS FACIL
   *
   *
   * ID
   * IMAGEN
   * ID CONTENIDO
   * TIPO CONTENIDO
   * FOLIO
   * DESCRIPCION = VALOR
   * SAVE = TRUE (SIRVE PARA PODER SABER SI LA IMAGEN QUE MUESTRO ESTA GUARDADA YA O NO)
   *
   */

  if (
    imagenesDigitalizaciones &&
    imagenesDigitalizaciones.length === undefined
  ) {
    if (imagenesDigitalizaciones?.imagenes) {
      const dataTipoContenido = getDatosTipoContenidos(
        imagenesDigitalizaciones.digitalizaciones_metadatos[0].id_tipo_contenidos,
        tipoContenidoList
      );

      cantFolio = imagenesDigitalizaciones.digitalizaciones_metadatos[0].folio;
      saveImages.push({
        id_digitalizaciones:
          imagenesDigitalizaciones.digitalizaciones_metadatos.id_digitalizaciones,
        id_digitalizaciones_metadatos:
          imagenesDigitalizaciones.digitalizaciones_metadatos[0].id,
        image: imagenesDigitalizaciones.imagenes.link || "",
        model: imagenesDigitalizaciones.imagenes.modelo_padre || "",
        tipo_contenidos: dataTipoContenido.id + " - " + dataTipoContenido.detalle,
        model_data: {
          id_tipo_contenidos: dataTipoContenido || "",
          id_contenidos: idContenido || "",
          folio: imagenesDigitalizaciones.digitalizaciones_metadatos.folio || "",
          valor: formatValor(imagenesDigitalizaciones.digitalizaciones_metadatos.valor),
        },
        meta_datos: esArray(imagenesDigitalizaciones.digitalizaciones_metadatos).map(item => ({
          id: item.id_metadatos,
          valor: formatValor(item.valor),
          id_digitalizaciones_metadatos: item.id,
          label_form: item.label_form,
          fuente: item.fuente || 'standard',
        })),
        meta_datos_concat: esArray(imagenesDigitalizaciones.digitalizaciones_metadatos)
          .map(item => `${item.label_form}: ${formatValor(item.valor)}`)
          .join(', '),
        save: true,
      });
    }
  } else {
    imagenesDigitalizaciones.forEach((digitalizacion) => {
  if (digitalizacion?.imagenes) {
    const metadata = esArray(digitalizacion.digitalizaciones_metadatos)[0];

    const dataTipoContenido = metadata
      ? getDatosTipoContenidos(metadata.id_tipo_contenidos, tipoContenidoList)
      : null;

    if (metadata?.folio && cantFolio < metadata.folio) {
      cantFolio = metadata.folio;
    }

    saveImages.push({
      id_digitalizaciones: metadata?.id_digitalizaciones || digitalizacion?.id || "",
      id_digitalizaciones_metadatos: metadata?.id || "",
      image: digitalizacion.imagenes.link || "",
      model: digitalizacion.imagenes.modelo_padre || "",
      model_data: {
        id_tipo_contenidos: dataTipoContenido?.id || "",
        id_contenidos: idContenido || "",
        folio: metadata?.folio || "",
        valor: formatValor(metadata?.valor),
      },
      tipo_contenidos: dataTipoContenido
        ? `${dataTipoContenido.id} - ${dataTipoContenido.detalle}`
        : "",
      meta_datos: esArray(digitalizacion.digitalizaciones_metadatos).map(item => ({
        id: item.id_metadatos,
        valor: formatValor(item.valor),
        id_digitalizaciones_metadatos: item.id,
        label_form: item.label_form,
        fuente: item.fuente || 'standard',
      })),
      meta_datos_concat: esArray(digitalizacion.digitalizaciones_metadatos)
        .map(item => `${item.label_form}: ${formatValor(item.valor)}`)
        .join(', '),
      save: true,
    });
  }
});

  }

  return { saveImages, cantFolio };
};


//NOTE FUNCION PARA PODER OBTNER EL OBJETO COMPLETO DE UN TIPO DE CONTENIDO, MEDIANTE UN ID
const getDatosTipoContenidos = (id, tipoContenidoList) => {
  let listTipoContenido = [];
  if (tipoContenidoList.length > 0) {
    listTipoContenido = tipoContenidoList;
  }
  let tipoContenido = listTipoContenido.find((item) => item.id === id);
  return tipoContenido;
};
